export { default } from './LanguageSwitcher';
